import { TrackerUtil } from '../../../tracking/TrackerUtil';

export * from './Footer';

export interface FooterLink {
  displayName: string;
  url: string;
  onClick: () => void | undefined;
}

export const BottomFooterLinks: ReadonlyArray<FooterLink> = [
  {
    displayName: 'Impressum',
    url: 'https://www.techem.de/impressum',
    onClick: () => {
      TrackerUtil.trackLinkClick('footer_link_legal-notice', 'link_legal-notice');
    }
  },
  {
    displayName: 'Datenschutz',
    url: '/onboarding#/datenschutz',
    onClick: () => {
      TrackerUtil.trackLinkClick('footer_link_data-privacy', 'link_data-privacy');
    }
  },
  {
    displayName: 'AGB',
    url: '/onboarding#/agb',
    onClick: () => {
      TrackerUtil.trackLinkClick('footer_link_terms-and-conditions', 'link_terms-and-conditions');
    }
  },
  {
    displayName: 'Widerruf',
    url: '/onboarding#/widerruf',
    onClick: () => {
      TrackerUtil.trackLinkClick('footer_link_revocation', 'link_revocation');
    }
  },
  // {
  //   displayName: 'Online-Kündigung',
  //   url: 'https://www.techem.com/de/de/services/online-kuendigung',
  //   onClick: () => {
  //     TrackerUtil.trackLinkClick('footer_link_termination', 'link_termination');
  //   }
  // },
  {
    displayName: 'Techem GmbH',
    url: 'https://www.techem.com/de/de',
    onClick: () => {}
  }
];
